export default {
    error: "检索订单时出现问题。请刷新您的浏览器。",
    title: "订单历史记录",
    loadMore: "加载更多",
    noOrders: "没有订单",
    user: {
        loadMore: "加载更多",
        product: {
            title: "命令",
            tracking: "追踪",
            quantity: "数量",
            reason: "原因",
            transfer: {
                sender: "发件人",
                receiver: "接收者"
            },
            control: {
                cancel: {
                    cta: "点击取消",
                    tooltip: "点击取消此项",
                    message: "我们已取消您的订单。"
                },
                received: {
                    cta: "标记为已收到",
                    tooltip: "点击确认发货",
                    message: "感谢您确认已收到产品。"
                },
                notReceived: {
                    cta: "标记为未收到",
                    tooltip: "点击确认未送达"
                },
                hide: {
                    cta: "隐藏商品",
                    tooltip: "单击可隐藏列表中的项目"
                }
            }
        }
    }
}